import React from 'react';
import './TextField.css';

const Input = React.forwardRef(({ className = '', ...props }, ref) => (
  <input
    ref={ref}
    className={`text-field-input ${className}`}
    {...props}
  />
));

const TextField = ({ label, children, className = '', ...props }) => {
  return (
    <div className={`text-field ${className}`} {...props}>
      {label && <label className="text-field-label">{label}</label>}
      {children}
    </div>
  );
};

TextField.Input = Input;

export { TextField }; 